var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoreVert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "more_vert",
    clipPath: "url(#clip0_145_5716)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.66634 5.33317C9.39967 5.33317 9.99967 4.73317 9.99967 3.99984C9.99967 3.2665 9.39967 2.6665 8.66634 2.6665C7.93301 2.6665 7.33301 3.2665 7.33301 3.99984C7.33301 4.73317 7.93301 5.33317 8.66634 5.33317ZM8.66634 6.6665C7.93301 6.6665 7.33301 7.2665 7.33301 7.99984C7.33301 8.73317 7.93301 9.33317 8.66634 9.33317C9.39967 9.33317 9.99967 8.73317 9.99967 7.99984C9.99967 7.2665 9.39967 6.6665 8.66634 6.6665ZM8.66634 10.6665C7.93301 10.6665 7.33301 11.2665 7.33301 11.9998C7.33301 12.7332 7.93301 13.3332 8.66634 13.3332C9.39967 13.3332 9.99967 12.7332 9.99967 11.9998C9.99967 11.2665 9.39967 10.6665 8.66634 10.6665Z",
    fill: "#323232"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_145_5716"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.666504)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreVert);
export default __webpack_public_path__ + "static/media/more_vert.7ca74c5bef428c3c08b9b8df02c3f8a7.svg";
export { ForwardRef as ReactComponent };